import React from 'react';
import { useImpersonation } from '../../contexts/ImpersonationContext';

const AdminImpersonationBanner = () => {
  const { active, displayName, tier, viewType, stopImpersonation } = useImpersonation();

  if (!active) return null;

  return (
    <div className="bg-amber-500 text-black px-4 py-2 flex items-center justify-between z-50 sticky top-0 shadow-md">
      <div className="flex items-center space-x-2 text-sm font-semibold">
        <span>🔍 Admin View Mode:</span>
        <span>Viewing as {displayName} ({tier}) - {viewType === 'child' ? 'Child View' : 'Parent View'}</span>
      </div>
      <button 
        onClick={() => {
          stopImpersonation();
          window.location.href = '/admin'; // Force redirect to admin dashboard
        }}
        className="text-xs bg-black text-white px-3 py-1 rounded hover:bg-gray-800 transition-colors"
      >
        Exit View Mode
      </button>
    </div>
  );
};

export default AdminImpersonationBanner;
